import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoggedInDashboard from "../components/LoggedInDashboard";
import LoggedOutLanding from "../components/LoggedOutLanding";

function Home() {
  return (
    <>
      <AuthenticatedTemplate>
        <LoggedInDashboard />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <LoggedOutLanding />
      </UnauthenticatedTemplate>
    </>
  );
}

export default Home;
